module.exports = __webpack_public_path__ + "img/logo_primary.737520c7.svg";